import { css, keyframes } from 'styled-components';

export const floatUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const fadeInBlur = keyframes`
  from { 
    opacity: 0;
    filter: blur(3px);
  }
  to { 
    opacity: 1;
    filter: blur(0);
  }
`;

export const revealStyle = css<{ $visible: boolean }>`
  opacity: 0;
  transform: translateY(50px);

  ${({ $visible }) =>
    $visible &&
    css`
      animation: ${floatUp} 1.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
    `}
`;

export const revealDelayStyle = css<{ $visible: boolean; $delay: number }>`
  opacity: 0;
  transform: translateY(50px);

  ${({ $visible, $delay }) =>
    $visible &&
    css`
      animation: ${floatUp} 1.5s cubic-bezier(0.34, 1.56, 0.64, 1) ${$delay}ms forwards;
    `}
`;

export const fadeRevealStyle = css<{ $visible: boolean; $delay: number }>`
  opacity: 0;

  ${({ $visible, $delay }) =>
    $visible &&
    css`
      animation: ${fadeIn} 1.8s cubic-bezier(0.34, 1.56, 0.64, 1) ${$delay}ms forwards;
    `}
`;

export const fadeBlurRevealStyle = css<{ $visible: boolean; $delay: number }>`
  opacity: 0;
  filter: blur(3px);

  ${({ $visible, $delay }) =>
    $visible &&
    css`
      animation: ${fadeInBlur} 1.5s cubic-bezier(0.25, 1, 0.3, 1) ${$delay}ms forwards;
    `}
`;
